import get from "lodash/get";
import { apiShop } from "../config";
import { strapiFetch } from "./strapiCompatibility";

const getDiscount = async (code) => {
  const res: any = await strapiFetch(`${apiShop}/discount?code=${code}`);
  if (get(res, "data.data[0]")) res.data.data = res.data.data[0];
  return res;
};

export { getDiscount };
